import { isString } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";

const propTypes = {
  /**
   * Error loading the table.
   * Note: data has to be empty in order to show `NoDataIndication`
   */
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
  ]),
  /**
   * If true, indicates that the table is loading
   */
  loading: PropTypes.bool,
  /**
   * Custom label shown when the table has no data and there is no error or loading state.
   * Overrides the default "No data" message.
   */
  noDataLabel: PropTypes.string,
};

function NoDataIndication(props) {
  const { error = null, loading = false, noDataLabel = null } = props ?? {};

  let message = noDataLabel ?? <FormattedMessage id="UIC.GENERAL.NO_DATA" />;
  if (loading) {
    message = <FormattedMessage id="UIC.TABLE.LOADING" />;
  } else if (error && isString(error)) {
    message = error;
  } else if (error) {
    // unknown error
    message = <FormattedMessage id="UIC.TABLE.ERROR" />;
  }

  return <div>{message}</div>;
}

NoDataIndication.propTypes = propTypes;

export default NoDataIndication;
